import CardWithShadow from "@/components/CardWithShadow";
import Text from "@/components/Text";
import Theme from "@/utils/theme";
import { Box, CircularProgress } from "@mui/material";
import Spacer from "@/components/Spacer";
import ShapedAccordion from "@/components/ShapedAccordion";
import AccordionSummary from "./components/AccordionSummary";
import AccordionDetailsList from "./components/AccordionDetailsList";
import { useChallenges } from "./useChallenges";
import { useStages } from "@/context/StagesContext";
import TotalChallenges from "@/ui/icons/TotalChallenges";
import SectionDescription from "../../components/SectionDescription";
import ChallengesInfoCard from "./components/ChallengesInfoCard";
import { useUser } from "@/context/UserContext";
import SadFaceIcon from "/assets/icons/sad-face.svg";
import Dialog from "@/components/Dialog";
import { useNavigate } from "react-router-dom";
import PartyIcon from "/assets/icons/party.svg";

function Challenges() {
  const {
    completedChallenges,
    totalChallenges,
    setExpandedIndexes,
    getIsOpenAccordion,

    challengesPerStage,
    updateChallengePerStage,
  } = useChallenges();
  const { userInfo } = useUser();
  const {
    stages,
    isLoading,
    isSemiFinalist,
    isValidStage,
    currentStage,
    isStageClosed,
  } = useStages();
  const navigate = useNavigate();

  if (!userInfo) return null;

  if (isSemiFinalist && isValidStage && currentStage?.isFinalStage) {
    return (
      <Dialog
        isOpen={true}
        icon={<img src={PartyIcon} />}
        text={
          "Parabéns! Você garantiu sua vaga no Reality Show e está entre os 10 melhores do Brasil. Mas ATENÇÃO essa informação é sigilosa, não compartilhe com ninguém."
        }
        confirmButtonText="Voltar"
        onConfirm={() => navigate(-1)}
      />
    );
  }

  if (!isValidStage && isStageClosed)
    return (
      <Dialog
        isOpen={true}
        icon={<img src={SadFaceIcon} />}
        text="Infelizmente não foi dessa vez. Você não avançou para a próxima etapa. Mas não deixe de tentar na próxima edição."
        confirmButtonText="Voltar"
        onConfirm={async () => {
          navigate(-1);
        }}
      />
    );

  return (
    <div>
      <ChallengesInfoCard />

      <SectionDescription
        title="Complete os desafios"
        description="Mestre, aqui você deverá {{completar}} os desafios disponíveis para {{conquistar}} mais {{pontos}}. Clique em {{'Iniciar desafio'}} para começar. Fique atento: caso algum desafio {{seja reprovado}}, você poderá {{tentar novamente}} até a finalização desta etapa."
      />

      <CardWithShadow mt="1.5rem" py="1rem">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          px="1.5rem"
        >
          <Text color={Theme.colors.icon.default}>Lista de Desafios</Text>

          <Box
            display="flex"
            border={`1px solid ${Theme.colors.neutral.light}`}
            p="0.5rem"
            alignItems="center"
            borderRadius="0.5rem"
          >
            <TotalChallenges />

            <Text ml="0.5rem" color={Theme.colors.text.secondary}>
              Total Concluído:{" "}
            </Text>
            <Text color={Theme.colors.text.primary}>
              <Text color={Theme.colors.brand.secondary}>
                {completedChallenges}
              </Text>
              /{totalChallenges}
            </Text>
          </Box>
        </Box>

        <Spacer height="1rem" />
        <Box px={{ xs: "0px", sm: "2rem" }}>
          {isLoading && (
            <Box display="flex" justifyContent="center" p="1rem">
              <CircularProgress size="1rem" />
            </Box>
          )}
          <ShapedAccordion
            onChangeExpanded={setExpandedIndexes}
            items={
              stages.map((item, index) => ({
                summary: (
                  <AccordionSummary
                    stepNumber={index + 1}
                    title={item.subTitle}
                    totalComplete={item.completedChallenges}
                  />
                ),
                details: (
                  <AccordionDetailsList
                    stageId={item.id}
                    isOpen={getIsOpenAccordion(index)}
                    onChangeChallengesAmount={(val) =>
                      updateChallengePerStage(item.id, val)
                    }
                  />
                ),
                hidden: challengesPerStage[item.id] === 0,
              })) ?? []
            }
            fixedIndex={(stages?.length ?? 0) - 1}
          />
        </Box>
      </CardWithShadow>
    </div>
  );
}

export default Challenges;
